<template>
  <v-container fluid>
    <v-row justify="space-around" class="fill-height" align="center">
      <v-col cols="3">
        <v-autocomplete
          v-model="selectedGeotag"
          :items="selectItems"
          item-value="id"
          item-text="name"
          :search-input.sync="search"
          outlined
          dense
          small-chips
          autofocus
          label="Geotag"
          clearable
          hide-selected
          return-object
          @change="navigate"
        >
          <template v-slot:item="{ item }">
            <v-list-item-avatar
              color="indigo"
              class="headline font-weight-light white--text"
            >
              {{ item.name.charAt(0) }}
            </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title v-text="item.name" />
              <v-list-item-subtitle v-text="item.shortcut" />
            </v-list-item-content>
          </template>
        </v-autocomplete>
        <v-row>
          <v-text-field label="first row text" v-model="preview.row1" />
          <TwoColorsPicker
            @change="(val) => preview.textColorRow1 = val"
          />
        </v-row>
        <v-row>
          <v-text-field label="second row text" v-model="preview.row2" />
          <TwoColorsPicker
            @change="(val) => preview.textColorRow2 = val"
          />
        </v-row>
        <v-color-picker
          v-model="preview.color"
          dot-size="25"
          hide-mode-switch
          mode="rgba"
          show-swatches
          swatches-max-height="200"
        />
      </v-col>
      <v-col class="fill-height" lg="3" md="4" sm="6">
        <router-view
          :preview.sync="preview"
          @updated="fillSelect"
          @resetBadge="resetBadge"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import debounce from 'lodash.debounce';
import TwoColorsPicker from '../../components/TwoColorsPicker.vue';

const lsKey = 'router-deeplink-image-constructor-settings';
const basicFontForStyle = 16;

export default {
  name: 'Index',
  components: {
    TwoColorsPicker,
  },
  data() {
    return {
      selectedGeotag: null,
      selectItems: [],
      search: '',

      bannerDefaultPositionAndColor: {
        color: 'FFED54BF',
        textColorRow1: 'black',
        textColorRow2: 'black',
        badgeLeft: 0,
        badgeTop: 60,
        badgeHeight: 100,
        badgeWidth: 400,
        frameLeft: 0,
        frameTop: 0,
        frameWidth: 400,
        framePosition: 'center',
        fontSize: basicFontForStyle,
      },
      preview: localStorage.getItem(lsKey)
        ? JSON.parse(localStorage.getItem(lsKey))
        : {
          row1: 'geotag name',
          row2: 'second row',
          ...this.bannerDefaultPositionAndColor,
        },
    };
  },

  created() {
    // this.resetBadge();

    this.saveSettings = debounce(() => {
      localStorage.setItem(lsKey, this.previewWatchTrigger);
    }, 1000);

    this.searchGeotag = debounce((val) => {
      this.$requestHelpers
        .post(
          'api/admin/geotag/filteredAndPaginated',
          {
            itemsPerPage: -1,
            filters: { name: val },
            sortBy: ['name'],
            sortDesc: [false],
            is_light: true,
          },
        )
        .then(({ data }) => { this.selectItems = data.data.filter((p) => p.videodata_count); });
    }, 1000);
  },

  deactivated() {
    this.$destroy();
  },

  computed: {
    previewWatchTrigger() {
      return JSON.stringify(this.preview);
    },
  },

  methods: {
    fillSelect(geotag) {
      if (this.selectedGeotag === null || this.selectedGeotag.id !== geotag.id) {
        this.selectItems.push(geotag);
        this.selectedGeotag = geotag;
      }

      this.preview.row1 = this.selectedGeotag.name;
      this.saveSettings();
    },

    navigate() {
      if (!this.selectedGeotag) {
        this.$router.push({ name: 'banner-constructor-route' });
      } else if (this.$route.params.geotagId !== this.selectedGeotag.id.toString()) {
        this.$router.push({
          name: 'banner-constructor-route-geotag',
          params: { geotagId: this.selectedGeotag.id.toString() },
        });
        this.preview.row1 = this.selectedGeotag.name;
      }
    },

    resetBadge() {
      this.preview = {
        row1: this.preview.row1,
        row2: this.preview.row2,
        ...this.bannerDefaultPositionAndColor,
      };
    },
  },

  watch: {
    previewWatchTrigger() {
      this.saveSettings();
    },

    search(val) {
      if (!val || val.length < 2) return;
      this.searchGeotag(val);
    },
  },
};
</script>
